import(/* webpackMode: "eager" */ "/home/runner/work/eon-service/eon-service/frontend/apps/eon/src/app/error.tsx");
